export const MerchantSelectionConfirmDialogViewErrorStyles = {
  title: 'text-red100 text-24px font-semibold',
  description: 'text-14px text-gray mt-6',
  closeIconContainer: 'flex justify-end',
  closeIcon: 'cursor-pointer',
}
